import React, { Component } from "react";
import PropTypes from "prop-types";
import ColoredHistogramSeries from "./ColoredHistogramSeries";
import LineSeries from "./LineSeries";

/**
 * DDI (Índice divergência direcional 2) — painel próprio: histograma DDI
 * (colorido por sinal) + linha zero + 2 linhas de sinal (ADDI, AD). Compõe o
 * ColoredHistogramSeries genérico com dois LineSeries. yAccessor(d) retorna
 * { value, direction, addi, ad }.
 */
class DDISeries extends Component {
  constructor(props) {
    super(props);
    this.histAccessor = this.histAccessor.bind(this);
    this.addiAccessor = this.addiAccessor.bind(this);
    this.adAccessor = this.adAccessor.bind(this);
  }
  histAccessor(d) {
    const v = this.props.yAccessor(d);
    return v ? { value: v.value, direction: v.direction } : undefined;
  }
  addiAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.addi;
  }
  adAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.ad;
  }
  render() {
    const {
      increasingColor,
      decreasingColor,
      strokeZeroLine,
      strokeAddi,
      strokeAd,
      className,
    } = this.props;
    return (
      <g className={className}>
        <ColoredHistogramSeries
          yAccessor={this.histAccessor}
          increasingColor={increasingColor}
          decreasingColor={decreasingColor}
          strokeZeroLine={strokeZeroLine}
        />
        <LineSeries
          yAccessor={this.addiAccessor}
          stroke={strokeAddi}
          fill="none"
        />
        <LineSeries yAccessor={this.adAccessor} stroke={strokeAd} fill="none" />
      </g>
    );
  }
}

DDISeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  increasingColor: PropTypes.string.isRequired,
  decreasingColor: PropTypes.string.isRequired,
  strokeZeroLine: PropTypes.object,
  strokeAddi: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeAd: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

DDISeries.defaultProps = {
  increasingColor: "#00DD00",
  decreasingColor: "#FF0000",
  strokeZeroLine: { color: "#666666", dash: "Solid", width: 1, opacity: 1 },
  strokeAddi: { color: "#FF0000" },
  strokeAd: { color: "#0000B4" },
  className: "react-stockcharts-ddi-series",
};

export default DDISeries;
